import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { WysiwygEditor } from "src/library/components/WysiwygEditor";

import { IOrderNote } from "../../api/orders.api";

interface OrderAdminNoteModalProps {
  onConfirm: (note: string, id?: number) => void;
  handleDismiss: () => void;
  show: boolean;
  noteObj?: IOrderNote;
}

const OrderAdminNoteModal: React.ReactFCWithChildren<OrderAdminNoteModalProps> = ({
  onConfirm, handleDismiss, show, noteObj
}) => {
  const [ note, setOrderNote ] = React.useState("");

  const addNoteForm = () => {
    return (
      <WysiwygEditor
        initalValue={noteObj && noteObj.body}
        handleChange={note => setOrderNote(note)}
      />
    );
  };

  return (
    <Modal
      small
      actions={[
        {
          name: "Go back",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: "Confirm",
          action: () => {
            if (note) {
              onConfirm(note, noteObj && noteObj.id);
            }

            handleDismiss();
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
      content={addNoteForm()}
      body="Leave a note on this order"
      type="confirm"
      title=""
      show={show}
    />
  );
};

export default OrderAdminNoteModal;
